export class RecoverAccountModel {
    public email: string;
}



// WEBPACK FOOTER //
// ./src/models/account/account.recover.model.ts